import type { CountryCode } from 'libphonenumber-js'

export const DEFAULT_PHONE_COUNTRY: CountryCode = 'RU'
export const MAX_PHONE_LENGTH = 20
